<div class="std-ta-center">
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m cancel_draft_title">Cancel Draft Success</h3>
    <p nxCopytext="normal" class="nx-margin-bottom-30">
      e-Quotation has been cancelled successfully.
    </p>
    <button nxModalClose nxButton="primary" type="button">
      OK
    </button>
</div>